/**
 * Esquema Zod del dominio de Actividad de usuarios.
 *
 * El dominio es de **lectura**: el único parámetro de "formulario" que viaja a la
 * API es el período del filtro (`?period=`). Se valida con Zod que sea uno de los 5
 * valores admitidos por el backend (`day`/`week`/`month`/`7days`/`all`), de modo
 * que la pantalla nunca solicite un período inválido. El tipo se **infiere** del
 * esquema (`z.infer`), no se escribe a mano (`docs/frontend_conventions.md`,
 * Validación).
 */
import { z } from "zod";

/**
 * Período del resumen de actividad. Coincide EXACTAMENTE con los valores que acepta
 * `ActivityService.resumen` (vía `summary` de la API): `day` (por defecto), `week`,
 * `month`, `7days`, `all`.
 */
export const activityPeriodSchema = z.enum([
  "day",
  "week",
  "month",
  "7days",
  "all",
]);

/** Período de actividad (inferido del esquema). */
export type ActivityPeriod = z.infer<typeof activityPeriodSchema>;
